/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">SW-1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">SW-2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">SW-1 — VLAN 15 named OPS</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">SW-2 — VLAN 66 named ENGINEERING</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">SW-1 e0/1 — access port for PC1 (VLAN 15)</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SW-2 e0/1 — access port for PC2 (VLAN 66)</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 5 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task5Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task5Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task5Done?'#28C76F':'#4a5568'}">5</span>
              <span class="font-semibold text-sm flex-1">e0/2 → LLDP only &nbsp;|&nbsp; e0/0 → CDP only</span>
              <span class="text-xs font-medium" :class="task5Done?'text-success':'text-grey'">{{ task5Progress }}/20</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t5-'+swk" class="mb-3">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1 mb-1">
                  <div v-for="item in task5GlobalItems" :key="'t5-'+swk+'-g-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
                <p class="text-xs ml-1 mb-1" style="color:#9ca3af">int e0/2 — LLDP on, CDP off</p>
                <div class="space-y-1 ml-1 mb-1">
                  <div v-for="item in task5E02Items" :key="'t5-'+swk+'-2-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
                <p class="text-xs ml-1 mb-1" style="color:#9ca3af">int e0/0 — CDP on, LLDP off</p>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task5E00Items" :key="'t5-'+swk+'-0-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
              <p class="text-xs mt-1 ml-1" style="color:#6b7280">Verify: <code>show cdp neighbors</code> / <code>show lldp neighbors</code> on SW-1</p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show cdp neighbors" or "show lldp neighbors" to verify.';

const mkCommands = (swk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(swk),
  configure:  (x) => vm.iosConfigure(swk, x),
  conf:       (x) => vm.iosConfigure(swk, x),
  vlan:       (x) => vm.iosVlan(swk, x),
  name:       (x) => vm.iosName(swk, x),
  interface:  (x) => vm.iosInterface(swk, x),
  int:        (x) => vm.iosInterface(swk, x),
  switchport: (x) => vm.iosSwitchport(swk, x),
  lldp:       (x) => vm.iosLldp(swk, x),
  cdp:        (x) => vm.iosCdp(swk, x),
  no:         (x) => vm.iosNo(swk, x),
  show:       (x) => vm.iosShow(swk, x),
  exit:       () => vm.iosExit(swk),
  end:        () => vm.iosEnd(swk),
  copy:       (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/VLAN_CDP_LLDP_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentVlan: null, currentIf: null },
      sw2: { mode: 'exec', currentVlan: null, currentIf: null },

      // sw1: task1(2) + task3(3) + task5(10) + saved(1) = 16
      sw1Completion: {
        vlan15: false, vlan15Name: false,
        e01If: false, e01Access: false, e01Vlan: false,
        lldpRun: false, cdpRun: false,
        e02If: false, e02LldpTx: false, e02LldpRx: false, e02NoCdp: false,
        e00If: false, e00NoLldpTx: false, e00NoLldpRx: false, e00CdpEnable: false,
        saved: false,
      },
      // sw2: task2(2) + task4(3) + task5(10) + saved(1) = 16
      sw2Completion: {
        vlan66: false, vlan66Name: false,
        e01If: false, e01Access: false, e01Vlan: false,
        lldpRun: false, cdpRun: false,
        e02If: false, e02LldpTx: false, e02LldpRx: false, e02NoCdp: false,
        e00If: false, e00NoLldpTx: false, e00NoLldpRx: false, e00CdpEnable: false,
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,

      task1Items: [
        { key: 'vlan15',     label: 'vlan 15' },
        { key: 'vlan15Name', label: 'name OPS' },
      ],
      task2Items: [
        { key: 'vlan66',     label: 'vlan 66' },
        { key: 'vlan66Name', label: 'name ENGINEERING' },
      ],
      task3Items: [
        { key: 'e01If',    label: 'interface e0/1' },
        { key: 'e01Access', label: 'switchport mode access' },
        { key: 'e01Vlan',  label: 'switchport access vlan 15' },
      ],
      task4Items: [
        { key: 'e01If',    label: 'interface e0/1' },
        { key: 'e01Access', label: 'switchport mode access' },
        { key: 'e01Vlan',  label: 'switchport access vlan 66' },
      ],
      task5GlobalItems: [
        { key: 'lldpRun', label: 'lldp run' },
        { key: 'cdpRun',  label: 'cdp run' },
      ],
      task5E02Items: [
        { key: 'e02If',     label: 'interface e0/2' },
        { key: 'e02LldpTx', label: 'lldp transmit' },
        { key: 'e02LldpRx', label: 'lldp receive' },
        { key: 'e02NoCdp',  label: 'no cdp enable' },
      ],
      task5E00Items: [
        { key: 'e00If',        label: 'interface e0/0' },
        { key: 'e00NoLldpTx',  label: 'no lldp transmit' },
        { key: 'e00NoLldpRx',  label: 'no lldp receive' },
        { key: 'e00CdpEnable', label: 'cdp enable' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-vlan') return 'SW-1(config-vlan)#';
      if (m === 'config-if')   return 'SW-1(config-if)#';
      if (m === 'config')      return 'SW-1(config)#';
      return 'SW-1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-vlan') return 'SW-2(config-vlan)#';
      if (m === 'config-if')   return 'SW-2(config-if)#';
      if (m === 'config')      return 'SW-2(config)#';
      return 'SW-2#';
    },

    task1Progress() { return [this.sw1Completion.vlan15, this.sw1Completion.vlan15Name].filter(Boolean).length; },
    task1Done()     { return this.task1Progress === 2; },

    task2Progress() { return [this.sw2Completion.vlan66, this.sw2Completion.vlan66Name].filter(Boolean).length; },
    task2Done()     { return this.task2Progress === 2; },

    task3Progress() {
      const c = this.sw1Completion;
      return [c.e01If, c.e01Access, c.e01Vlan].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 3; },

    task4Progress() {
      const c = this.sw2Completion;
      return [c.e01If, c.e01Access, c.e01Vlan].filter(Boolean).length;
    },
    task4Done() { return this.task4Progress === 3; },

    task5Progress() {
      const keys = ['lldpRun','cdpRun','e02If','e02LldpTx','e02LldpRx','e02NoCdp','e00If','e00NoLldpTx','e00NoLldpRx','e00CdpEnable'];
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return keys.flatMap(k => [c1[k], c2[k]]).filter(Boolean).length;
    },
    task5Done() { return this.task5Progress === 20; },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    swkLabel(k) { return k === 'sw1' ? 'SW-1' : 'SW-2'; },

    dot(val) {
      return { width: '8px', height: '8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^fa/, '')
        .replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion, this.sw2Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // sw1(16) + sw2(16) = 32
      if (score >= 32) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) { this[swk].mode = 'exec'; return createStdout(''); },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-vlan') {
        s.mode = 'config'; s.currentVlan = null; s.currentIf = null;
      } else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(swk) {
      this[swk].mode = 'exec'; this[swk].currentVlan = null; this[swk].currentIf = null;
      return createStdout('');
    },

    iosVlan(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config' && s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in global or VLAN configuration mode');
      const vlanId = String(x._[1] || '');
      if (!vlanId || isNaN(vlanId)) return createStderr('% Invalid input detected');
      s.mode = 'config-vlan'; s.currentVlan = vlanId; s.currentIf = null;
      const c = this[swk + 'Completion'];
      if (swk === 'sw1' && vlanId === '15' && !c.vlan15) { c.vlan15 = true; this.updateScore(); }
      if (swk === 'sw2' && vlanId === '66' && !c.vlan66) { c.vlan66 = true; this.updateScore(); }
      return createStdout('');
    },

    iosName(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in VLAN configuration mode');
      const nameRaw = (x._[1] || '');
      if (!nameRaw) return createStderr('% Invalid input detected');
      const nameUp = nameRaw.toUpperCase();
      const c = this[swk + 'Completion'];

      if (swk === 'sw1' && s.currentVlan === '15' && nameUp === 'OPS' && !c.vlan15Name) {
        c.vlan15Name = true; this.updateScore();
        return createStdout(this.guide(
          'VLAN 15 named OPS on SW-1. Devices in this VLAN share a broadcast domain isolated from other VLANs. ' +
          '→ Configure Task 2 on SW-2: "vlan 66" then "name ENGINEERING".'
        ));
      }
      if (swk === 'sw2' && s.currentVlan === '66' && nameUp === 'ENGINEERING' && !c.vlan66Name) {
        c.vlan66Name = true; this.updateScore();
        return createStdout(this.guide(
          'VLAN 66 named ENGINEERING on SW-2. ' +
          '→ Configure Task 3 on SW-1: assign e0/1 as an access port for VLAN 15.'
        ));
      }
      return createStdout('');
    },

    iosInterface(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      let ifNorm = this.normalizeIf(ifArg);
      // E0/0 → fa0/10 in Packet Tracer
      if (ifNorm === '0/10') ifNorm = '0/0';
      s.mode = 'config-if'; s.currentIf = ifNorm; s.currentVlan = null;
      const c = this[swk + 'Completion'];
      if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      else if (ifNorm === '0/2' && !c.e02If) { c.e02If = true; this.updateScore(); }
      else if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const ifn  = s.currentIf;

      if (sub1 === 'mode' && sub2 === 'access') {
        if (ifn === '0/1' && !c.e01Access) {
          c.e01Access = true; this.updateScore();
          const swName = this.swkLabel(swk);
          const vlan = swk === 'sw1' ? 15 : 66;
          return createStdout(this.guide(`${swName} e0/1 set to access mode. → "switchport access vlan ${vlan}".`));
        }
        return createStdout('');
      }

      if (sub1 === 'access' && sub2 === 'vlan') {
        const vlanId = String(x._[3] || '');
        if (ifn === '0/1' && !c.e01Vlan) {
          if (swk === 'sw1' && vlanId === '15') {
            c.e01Vlan = true; this.updateScore();
            return createStdout(this.guide('SW-1 e0/1 assigned to VLAN 15 (OPS). PC1 is now in the OPS broadcast domain. → Configure Task 4 on SW-2.'));
          }
          if (swk === 'sw2' && vlanId === '66') {
            c.e01Vlan = true; this.updateScore();
            return createStdout(this.guide('SW-2 e0/1 assigned to VLAN 66 (ENGINEERING). PC2 is now in the ENGINEERING broadcast domain. → Configure Task 5: enable LLDP and CDP.'));
          }
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosLldp(swk, x) {
      const s = this[swk];
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'run') {
        if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
        if (!c.lldpRun) { c.lldpRun = true; this.updateScore(); }
        return createStdout(this.guide(
          'LLDP enabled globally. LLDP (IEEE 802.1AB) is the vendor-neutral neighbor discovery standard — it works with non-Cisco routers and switches, unlike CDP. ' +
          'By default LLDP is disabled on Cisco IOS; "lldp run" activates it. → "cdp run" to also enable CDP globally.'
        ));
      }

      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');

      if (sub1 === 'transmit') {
        if (s.currentIf === '0/2' && !c.e02LldpTx) {
          c.e02LldpTx = true; this.updateScore();
          return createStdout(this.guide('LLDP TX enabled on e0/2. This interface will now send LLDP advertisements — R1 on the other end can discover this switch via LLDP. → "lldp receive".'));
        }
        return createStdout('');
      }

      if (sub1 === 'receive') {
        if (s.currentIf === '0/2' && !c.e02LldpRx) {
          c.e02LldpRx = true; this.updateScore();
          return createStdout(this.guide('LLDP RX enabled on e0/2. This interface now accepts incoming LLDP frames. → "no cdp enable" to suppress CDP on this LLDP-only port.'));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosCdp(swk, x) {
      const s = this[swk];
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'run') {
        if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
        if (!c.cdpRun) { c.cdpRun = true; this.updateScore(); }
        return createStdout(this.guide(
          'CDP enabled globally. CDP is Cisco-proprietary — only Cisco devices understand it. Enabling it explicitly here is best practice since it could have been disabled. ' +
          '→ "interface e0/2" to configure per-interface LLDP/CDP settings.'
        ));
      }

      if (sub1 === 'enable') {
        if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
        if (s.currentIf === '0/0' && !c.e00CdpEnable) {
          c.e00CdpEnable = true; this.updateScore();
          return createStdout(this.guide(
            `CDP explicitly enabled on ${this.swkLabel(swk)} e0/0. This inter-switch link now uses only CDP for neighbor discovery. ` +
            'Verify: run "show cdp neighbors" from SW-1 — SW-2 should appear as a CDP neighbor on this interface.'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosNo(swk, x) {
      const s    = this[swk];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      // no lldp transmit / no lldp receive
      if (sub1 === 'lldp') {
        if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
        if (sub2 === 'transmit' && s.currentIf === '0/0' && !c.e00NoLldpTx) {
          c.e00NoLldpTx = true; this.updateScore();
          return createStdout(this.guide('LLDP TX disabled on e0/0. This inter-switch link will not send LLDP advertisements. → "no lldp receive".'));
        }
        if (sub2 === 'receive' && s.currentIf === '0/0' && !c.e00NoLldpRx) {
          c.e00NoLldpRx = true; this.updateScore();
          return createStdout(this.guide('LLDP RX disabled on e0/0. This interface now ignores incoming LLDP frames — only CDP operates here. → "cdp enable" to explicitly confirm CDP.'));
        }
        return createStdout('');
      }

      // no cdp enable
      if (sub1 === 'cdp' && sub2 === 'enable') {
        if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
        if (s.currentIf === '0/2' && !c.e02NoCdp) {
          c.e02NoCdp = true; this.updateScore();
          return createStdout(this.guide(
            'CDP disabled on e0/2. This port now uses only LLDP for neighbor discovery — CDP advertisements are suppressed here. ' +
            '→ "interface e0/0" to configure the inter-switch link for CDP only.'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosShow(swk, x) {
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'cdp' && sub2 === 'neighbors') {
        const header =
          'Capability Codes: R - Router, T - Trans Bridge, B - Source Route Bridge<br>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;S - Switch, H - Host, I - IGMP, r - Repeater, P - Phone<br>' +
          'Device ID&nbsp;&nbsp;&nbsp;&nbsp;Local Intrfce&nbsp;&nbsp;&nbsp;Holdtme&nbsp;&nbsp;&nbsp;Capability&nbsp;&nbsp;Platform&nbsp;&nbsp;&nbsp;Port ID<br>';
        const cdpReady = c.cdpRun && c.e00CdpEnable;
        const other    = swk === 'sw1' ? 'Sw-2' : 'Sw-1';
        const rows     = cdpReady
          ? `${other}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;125&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3560&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/10`
          : this.guide('No CDP neighbors found — complete Task 5 CDP configuration (cdp run + cdp enable on e0/0) first.');
        return createStdout(header + rows);
      }

      if (sub1 === 'lldp' && sub2 === 'neighbors') {
        const header =
          'Capability codes:<br>' +
          '(R) Router, (B) Bridge, (T) Telephone, (C) DOCSIS Cable Device<br>' +
          '(W) WLAN Access Point, (P) Repeater, (S) Station, (O) Other<br>' +
          'Device ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Local Intf&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hold-time&nbsp;&nbsp;&nbsp;Capability&nbsp;&nbsp;Port ID<br>';
        const lldpReady = c.lldpRun && c.e02LldpTx && c.e02LldpRx;
        const router    = swk === 'sw1' ? 'R1' : 'R2';
        const rows      = lldpReady
          ? `${router}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Et0/2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;120&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;R&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Et0/0`
          : this.guide('No LLDP neighbors found — complete Task 5 LLDP configuration (lldp run + lldp transmit/receive on e0/2) first.');
        return createStdout(header + rows);
      }

      if (sub1 === 'vlan') {
        const rows = ['1    default                          active'];
        if (swk === 'sw1') {
          if (c.vlan15 && c.vlan15Name) rows.push('15   OPS                              active');
          else if (c.vlan15)            rows.push('15   VLAN0015                         active');
        }
        if (swk === 'sw2') {
          if (c.vlan66 && c.vlan66Name) rows.push('66   ENGINEERING                      active');
          else if (c.vlan66)            rows.push('66   VLAN0066                         active');
        }
        return createStdout(
          'VLAN Name                             Status    Ports<br>' +
          '---- -------------------------------- --------- ------<br>' +
          rows.join('<br>')
        );
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${this.swkLabel(swk)} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ Both switches saved — simulation complete!' : '→ Save the remaining switch.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

